import React from 'react';
import { Modal, Collapse, Button, Row, Col, Card, Typography, Spin, Divider, Input, Image } from 'antd';
import evmLib from '../evmLib';
import Lib from '../Lib';
import moment from 'moment';
import TXAlert from './TXAlert';

const { Panel } = Collapse;
const { Title } = Typography;
const {
  TRADE_LINK,
  ZV_LINK,
  ZVR_LINK
} = require('../config');


class ZoVault extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stakeAmount: ''
    };
  }

  async componentDidMount() {
    const blockchainTime = await evmLib.getBlockchainTime();
    this.setState({ blockchainTime });

    await this.refreshVaultData();
  }

  async getSnapshotBeforeUpdate(prevProps, prevState) {
    const prevMetamask = prevProps.metamask;
    const nextMetamask = this.props.metamask;

    if (!prevMetamask && nextMetamask) {
      await this.refreshVaultDataUser();
    }
  }

  componentDidUpdate() {
    return true;
  }

  modalError(msg) {
    Modal.error({
      title: 'Vault Error',
      centered: true,
      maskClosable: true,
      content: msg,
      okType: 'outline'
    });
  }

  async refreshVaultData() {
    this.setState({ vaultData: null });
    const vaultData = await evmLib.getZoVaultData();
    this.setState({ vaultData });
  }

  async refreshVaultDataUser() {
    this.setState({ vaultDataUser: null });
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();
    const vaultDataUser = await evmLib.getZoVaultDataUser(wallet);
    this.setState({ vaultDataUser });
  }

  componentWillUnmount() {
  }

  async claimVaultYield() {
    try {
      const signer = this.props.metamask.getSigner();
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.claimZoVaultYield(signer);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  async stakeVault() {
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();

    // 'Before stake/unstake, please claim unclaimed yield.'
    // 'Wallet dont have enough CFX. Buy CFX at SWAPPI.'
    const amount = this.state.stakeAmount;
    if (!amount || amount === '')
      return this.modalError('Please enter amount to stake/unstake.');

    const amountWei = evmLib.eth2wei(amount);
    const balance = await evmLib.getWalletBalance(wallet.address);

    if (Number(amount) < 1)
      return this.modalError('Required minimum stake is 1 CFX.');
    if (this.state.vaultDataUser && Number(this.state.vaultDataUser.unclaimedReward) > 0)
      return this.modalError('Before stake/unstake, please claim unclaimed yield');
    if (balance.lt(amountWei))
      return this.modalError('Wallet dont have enough CFX. Buy CFX at SWAPPI.');

    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.stakeZoVault(wallet, amount);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }

  }

  async unstakeVault() {
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();

    // 'Before stake/unstake, please claim unclaimed yield.'
    // 'Not enough CFX to unstake. Stake CFX first.' 
    const amount = this.state.stakeAmount;
    if (!amount || amount === '')
      return this.modalError('Please enter amount to stake/unstake.');

    if (this.state.vaultDataUser && Number(this.state.vaultDataUser.unclaimedReward) > 0)
      return this.modalError('Before stake/unstake, please claim unclaimed yield');
    if (this.state.vaultDataUser && Number(amount) > Number(this.state.vaultDataUser.numStake))
      return this.modalError('Not enough CFX to unstake. Stake CFX first.');


    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.unstakeZoVault(wallet, amount);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  renderAPYCalc() {
    const d = this.state.vaultData;
    const priceToken = Lib.to5digit(d.priceToken);
    const dailyInterest = Lib.to5digit(d.dailyInterest);
    const dailyInterestCfx = Lib.to5digit(d.dailyInterestCfx);
    const apyCalc1 = Lib.to5digit(d.apyCalc1);
    const apyCalc2 = Lib.to5digit(d.apyCalc2);

    return (
      <div style={{ textAlign: 'center' }}>
        <div>Price in CFX:</div>
        <div>1 TXT = {priceToken} CFX</div>
        <div>Avg. Daily Yield/CFX: {dailyInterest} TXT/CFX</div>
        <div>{dailyInterestCfx} CFX/CFX = {dailyInterestCfx}</div>
        <div>APY Calculation:</div>
        <div>(1 + {dailyInterestCfx})^365 - 1 * 100%</div>
        <div>{apyCalc1} - 1  * 100%</div>
        <div>{apyCalc2} * 100%</div>
      </div>
    );
  }

  render() {
    const title = 'ZO VAULT';
    const tokenName = 'CFX';
    const yieldName = 'TXT';
    const infoMsg1 = 'ZO VAULT is yield optimizer for CFX deposits at Zero One Flux. Start stake from 1 CFX and unstake waiting time only 1 hour.';
    const infoMsg2 = 'Trade CFX or TXT in SWAPPI';
    const unstakeEnableTime = '1 hour';
    const imgUrl = 'https://res.cloudinary.com/dey55ubjm/image/upload/v1660552313/tbotx/CFX.png';

    let apyInfo = <Spin />;
    let numStaked = '-';
    let unstakeAllowDate = '-';
    let nextRewardAvailable = '-';
    let unclaimedYield = '-';
    let noUserData = true;
    let enableUnstake = false;
    let numOwned = '-';
    let approved = true;
    let apyCalc = null;
    let enableMax = false;

    const now = this.state.blockchainTime ? moment.unix(this.state.blockchainTime) : moment();
    let info = (
      <Col xs={24}>
        <Collapse accordion>
          <Panel header="Vault Information">
            <Row gutter={[8, 8]}>
              <Col xs={24}>
              <p>{infoMsg1}</p>
              <p>{infoMsg2}</p>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl('https://flux.01.finance/markets')}>VISIT ZERO ONE MARKET</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(ZV_LINK)}>VERIFY ZOVAULT CONTRACT</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(ZVR_LINK)}>VERIFY ZOREWARD CONTRACT</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(TRADE_LINK)}>TRADE CFX OR TXT</Button>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </Col>
    );

    if (this.state.vaultData) {
      const d = this.state.vaultData;
      apyInfo = <Title level={4}>APY {Lib.to2digit(d.apy)}%</Title>;
      nextRewardAvailable = moment.unix(d.nextRewardAvailable).format('DD/MM/YY HH:mm:ss');
      apyCalc = this.renderAPYCalc();

      if (this.state.vaultDataUser) {
        noUserData = false;
        const du = this.state.vaultDataUser;
        numOwned = du.ownedCFX;
        numStaked = du.numStake;
        unstakeAllowDate = moment.unix(du.unstakeTime).format('DD/MM/YY HH:mm:ss');
        unclaimedYield = Lib.to5digit(du.unclaimedReward);
        enableUnstake = now.isAfter(moment.unix(du.unstakeTime)) && Number(numStaked) > 0;
        enableMax = (Number(numOwned) > 0)
      }
    }

    let disableBtnYieldClaim = true;
    let txtYield = <div>&nbsp;</div>;

    if (Number(numStaked) > 0 && Number(unclaimedYield) > 0) {
      disableBtnYieldClaim = false;
      txtYield = (
        <div style={{ textAlign: 'center' }}>
          Unclaimed Yield: {unclaimedYield} {yieldName}
        </div>
      );
    } else if (nextRewardAvailable !== '-') {
      txtYield = (
        <div style={{ textAlign: 'center' }}>
          Yield Available: {nextRewardAvailable}
        </div>
      );
    }

    if (Number(numStaked) > 0 && Number(unclaimedYield) > 0) {
      disableBtnYieldClaim = false;
    }

    let txtUnstakeTime = (
      <div style={{ textAlign: 'center' }}>
        <div>Unstake will be enable {unstakeEnableTime} after last Stake</div>
      </div>
    );

    if (Number(numStaked) > 0 && !enableUnstake) {
      txtUnstakeTime = (
        <div style={{ textAlign: 'center' }}>
          <div>Unstake allowed after {unstakeAllowDate}</div>
        </div>
      );
    }

    let btnStake;
    let btnUnstake;
    if (approved) {
      btnStake = (
        <Col xs={12}>
          <Button disabled={noUserData} type='primary' block onClick={() => this.stakeVault()}>STAKE</Button>
        </Col>
      );
      btnUnstake = (
        <Col xs={12}>
          <Button disabled={noUserData || !enableUnstake} type='primary' block onClick={() => this.unstakeVault()}>UNSTAKE</Button>
        </Col>
      );
    }

    let calcInfo = (
      <Col xs={24} sm={24}>
        <div style={{ textAlign: 'center' }}>
          {apyCalc}
          <div>&nbsp;</div>
          {apyInfo}
          <div><Button type="link" onClick={() => this.setState({ showAPYCalc: false })}>HIDE APY CALCULATION</Button></div>
        </div>
      </Col>
    );

    if (!this.state.showAPYCalc) {
      calcInfo = (
        <Col xs={24} sm={24}>
          <div style={{ textAlign: 'center' }}>
            <Image
              height='64px'
              src={imgUrl}
            />
            <div>&nbsp;</div>
            <div>Stake {tokenName} Earn {yieldName}</div>
            {apyInfo}
            <div><Button type="link" onClick={() => this.setState({ showAPYCalc: true })}>SHOW APY CALCULATION</Button></div>
          </div>
        </Col>
      );
    }

    return (
      <Card title={
        <Title level={4}>{title}</Title>
      } style={{ height: '100%' }} headStyle={{ textAlign: 'center' }}>
        <TXAlert showTxPopup={this.state.showTxPopup} txStatus={this.state.txStatus} txHash={this.state.txHash}
          onBack={() => this.setState({ showTxPopup: false })} />
        <Row gutter={[8, 8]}>
          {info}
          <div>&nbsp;</div>
        </Row>
        <Row gutter={[8, 8]}>
          {calcInfo}
        </Row>
        <Divider />
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24}>
            <div style={{ textAlign: 'center' }}>
              <div>Staked: {numStaked} {tokenName}</div>
              {txtUnstakeTime}
              Owned: {numOwned} {tokenName}
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <Input disabled={!approved} addonAfter={tokenName} placeholder='Enter amount to stake/unstake'
                  value={this.state.stakeAmount}
                  onChange={(e) => this.setState({ stakeAmount: e.target.value })}
                />
              </div>
              <div>
                <Button disabled={!enableMax} type="link" onClick={() => this.setState({ stakeAmount: ('' + numOwned) })}>MAX</Button>
              </div>
            </div>
          </Col>
          {btnStake}
          {btnUnstake}
          <Col xs={24}>
            <Divider />
            {txtYield}
          </Col>
          <Col xs={24}>
            <Button disabled={noUserData || disableBtnYieldClaim} type='primary' block onClick={() => this.claimVaultYield()}>CLAIM</Button>
          </Col>
        </Row>
      </Card >
    );
  }

}

export default ZoVault;
